/* unplugin-vue-components disabled */import __unplugin_components_5 from '~icons/ep/close';
import { ElIcon as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_3 from '~icons/ep/check';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/drone/src/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全部修改");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("批量修改");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");
import { useAppStore } from '@/store/modules/app';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetAnnounceProductList, apiUsdkGetQuestionConf } from '@/api/usdk';
import HelpCustomDialog from './helpCustomDialog.vue';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const helpCustomDialogRef = ref();
    const multipleSelected = ref([]);
    const filter = ref({
      cids: undefined,
      gid: '',
      projectId: undefined,
      env: undefined
    });
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'cname'
    },
    // { label: '短信验证', prop: 'problemSmsVerify', slot: 'problemSmsVerify' },
    // { label: '账号问题', prop: 'problemAccount', slot: 'problemAccount' },
    {
      label: '联系客服',
      prop: 'problemContactCs',
      slot: 'problemContactCs'
    }, {
      label: '账号注销',
      prop: 'accountCancel',
      slot: 'accountCancel'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      const params = {
        gid: gameInfo.value.Id,
        env: 1,
        projectId: filter.value.projectId,
        cids: filter.value.cids
      };
      tableLoading.value = true;
      apiUsdkGetAnnounceProductList(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const handleClick = async (type, data) => {
      if (type === 'all') {
        helpCustomDialogRef.value.show({
          type,
          tableData: tableData.value,
          gameInfo: gameInfo.value
        });
      } else if (type === 'batchEdit') {
        helpCustomDialogRef.value.show({
          type,
          gameInfo: gameInfo.value,
          multipleSelected: multipleSelected.value
        });
      } else {
        const res = await getQuestionConf(gameInfo.value.Id, data);
        const obj = JSON.parse(JSON.stringify(data));
        helpCustomDialogRef.value.show({
          type,
          gameInfo: gameInfo.value,
          data: {
            ...obj,
            ...res.conf
          },
          questionConf: res.questionConf
        });
      }
    };
    const handleSuccess = () => {
      getTableData();
      multipleSelected.value = [];
    };
    const getQuestionConf = async (gid, data) => {
      const res = await apiUsdkGetQuestionConf({
        gid,
        cid: data.cid
      });
      if (res.code === 0) {
        const questionConf = res.data;
        const conf = {
          tel: res.data[0].val,
          logoutUrl: res.data[1].val
        };
        return {
          conf,
          questionConf
        };
      }
    };
    const handleChangeMultiple = async val => {
      multipleSelected.value = val;
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_i_ep_Check = __unplugin_components_3;
      const _component_el_icon = __unplugin_components_4;
      const _component_i_ep_Close = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, {
        label: "所属渠道"
      }, {
        default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
          modelValue: filter.value.cids,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filter.value.cids = $event),
          gid: _unref(gameInfo).Id,
          otherProps: {
            needIos: 1,
            isHero: 1
          }
        }, null, 8, ["modelValue", "gid"])]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "marginL20",
        type: "primary",
        onClick: getTableData
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => handleClick('all'))
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => handleClick('batchEdit')),
        disabled: multipleSelected.value.length === 0
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }, 8, ["disabled"])])]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        "is-multiple": "",
        onMultipleSelect: handleChangeMultiple
      }, _createSlots({
        problemContactCs: _withCtx(({
          scope
        }) => [scope.row.problemContactCs ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        accountCancel: _withCtx(({
          scope
        }) => [scope.row.accountCancel ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "danger",
          onClick: $event => handleClick('delete', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, [false ? {
        name: "problemSmsVerify",
        fn: _withCtx(({
          scope
        }) => [scope.row.problemSmsVerify ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))])
      } : undefined, false ? {
        name: "problemAccount",
        fn: _withCtx(({
          scope
        }) => [scope.row.problemAccount ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          color: "green",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Close)]),
          _: 1
        }))])
      } : undefined]), 1032, ["data", "loading"]), _createVNode(HelpCustomDialog, {
        ref_key: "helpCustomDialogRef",
        ref: helpCustomDialogRef,
        onSuccess: handleSuccess
      }, null, 512)], 64);
    };
  }
});